import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import MyDataTable from "../../myComponents/DataTable/MyDataTable";
import { feedBackListAPI } from "../../api/index";
import useLogout from "../../utils/Utils";
import { decrypt } from "../../utils/Encrypt";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Row } from "../../components/Component";

const FeedbackList = () => {
  const logout = useLogout();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    feedBackList();
  }, []);
  const feedBackList = () => {
    setIsLoading(true)
    feedBackListAPI()
      .then((res) => {
        // decrypt data
        const status = decrypt(res.data.status);
        if (status === "success") {
          setIsLoading(false)
          const decryptedResponse = decrypt(res.data.data.tableData);
          toast.success(res.data.message);
          setData(decryptedResponse);
          toast.clearWaitingQueue();
        } else if (status === "failed") {
          setIsLoading(false)
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
          setData([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {});
  };

  const [column, setColumn] = useState([
    {
      name: "Name",
      selector: (row) => `${row?.name}${" "}`,
      sortable: true,
      width: "180px",
    },
    {
      name: "Phone",
      selector: (row) => row?.phone,
      sortable: true,
      width: "140px",
    },
    {
      name: "Email",
      selector: (row) => row?.email,
      sortable: true,
      wrap: true,
      width: "250px",
    },
    {
      name: "Address",
      selector: (row) => row?.address,
      sortable: true,
      wrap: true,
    },
    {
      name: "FeedBack",
      selector: (row) => row?.feedback,
      sortable: true,
      wrap: true,
    },
  ]);
  return (
    <>
      <Head title={"FeedBack"} />
      <Content>
        <div className="container-fluid ">
          <BlockHead size={`sm`}>
            <BlockBetween>
              <BlockHeadContent>
                <BlockTitle page tag="h3">
                  {"Feedback"}
                </BlockTitle>
              </BlockHeadContent>
            </BlockBetween>
          </BlockHead>
          <Block>
            <Row className={`g-gs`}>
              <MyDataTable data={data} columns={column} title={"FeedBack List"} isLoading={isLoading} />
            </Row>
          </Block>
        </div>
      </Content>
    </>
  );
};

export default FeedbackList;
